import React from "react";

import "./index.scss";

const Main = ({ children }) => <div className="main">{children}</div>;

export default Main;
